import api from 'api';

export const loadNotificationsSettings = api(
  'GET /api/profile/notifications/settings'
);

export const updateNotificationsSettings = api(
  'PUT /api/profile/notifications/settings'
);
